import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import 'babel-polyfill'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

Vue.use(VueMeta)

export const bus = new Vue()

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
